// src/components/SinisterCardData/SinisterActions.tsx

"use client";

import { HolidayVillageOutlined, PublishedWithChangesOutlined } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";

interface SinisterActionsProps {
	onUpdatePropertyClick?: () => void;
	onUpdateStatusClick?: () => void;
	showButtonStatus?: boolean;
	showButtonProperty?: boolean;
}

export default function SinisterActions({ onUpdatePropertyClick, onUpdateStatusClick, showButtonStatus, showButtonProperty }: SinisterActionsProps) {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseMenu = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<IconButton onClick={handleOpenMenu}>
				<MoreVertIcon />
			</IconButton>

			<Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
				<MenuItem
					onClick={() => {
						onUpdatePropertyClick?.();
						handleCloseMenu();
					}}
					disabled={!showButtonProperty}
				>
					<ListItemIcon>
						<HolidayVillageOutlined fontSize="small" color="success" />
					</ListItemIcon>
					<ListItemText sx={{ color: "success.main" }}>Alterar situação do imóvel</ListItemText>
				</MenuItem>
				<Divider />

				<MenuItem
					onClick={() => {
						onUpdateStatusClick?.();
						handleCloseMenu();
					}}
					disabled={!showButtonStatus}
				>
					<ListItemIcon>
						<PublishedWithChangesOutlined fontSize="small" color="warning" />
					</ListItemIcon>
					<ListItemText sx={{ color: "warning.main" }}>Alterar Status do Sinistro</ListItemText>
				</MenuItem>
			</Menu>
		</>
	);
}
